export default __webpack_public_path__ + "static/media/RedHatDisplay-ExtraBold.3c908e72.ttf";